import { createClient } from '@supabase/supabase-js';

// Add validation for Supabase URL
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://pjhckyctpaxkboxchiyj.supabase.co';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InBqaGNreWN0cGF4a2JveGNoaXlqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDk0MzczMjksImV4cCI6MjA2NTAxMzMyOX0.jbS562z54c_FtQWh5P8MGeYaMBF1LGu6QyDsshEpBak';

// Validate URL before creating client
if (!supabaseUrl.startsWith('https://')) {
  throw new Error('Invalid Supabase URL');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    storage: window.localStorage
  }
});

// Test connection
export const testConnection = async () => {
  try {
    const { error } = await supabase.from('projects').select('count').limit(1);
    if (error) {
      console.error('Supabase connection test failed:', error.message);
      return false;
    }
    return true;
  } catch (err) {
    console.error('Supabase connection error:', err instanceof Error ? err.message : 'Unknown error');
    return false;
  }
};